export enum ButtonFace {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LINK = 'link',
  OUTLINED_PRIMARY = 'outlined-primary',
  OUTLINED_SECONDARY = 'outlined-secondary'
}
